module.exports = __webpack_public_path__ + "img/lifecycle-5.cb817921.jpg";